import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { SpinnerService } from '../modules/spinner/spinner.service';
import { ToasterService } from 'angular2-toaster';
import { Router } from '@angular/router';
@Injectable()
export class SearchService {

    public plans;
    public plansLength;

    public scale = {
        budget: [0, 200],
        data: [0, 21],
        calls: [0, 2200]
    };

    public steps = {
        budget: 5,
        data: 1,
        calls: 200
    };

    public defaultRanges = {
        budget: [10, 60],
        data: [1, 4],
        calls: [0, 400]
    };

    public ranges:any = {
        budget: [0, 60],
        data: [0, 4],
        calls: [0, 2200]
    };

    public currency = {
        budget: '$',
        data: 'GB',
        calls: 'min'
    };

    constructor(
        private http: HttpClient,
        private spinnerService: SpinnerService,
        private toasterService: ToasterService,
        private router: Router,
    ) {
    }

    SearchPlans(data) {

        for(let item in data){
            if(data[item][1] == 2200 || data[item][1] == 21){
                data[item][1] = 'unlimited';
            }
        };

        this.http.post<any>('https://lama-net.com/Plans/webApi/plan.php', data)
        .subscribe(result => {
            this.plans = result.result.data;
            this.plansLength = this.plans.length;

            this.spinnerService.loader = false;
            this.spinnerService.show = false;

        }, error => {
            this.spinnerService.loader = false;
            this.spinnerService.show = false;

            this.toasterService.pop('error', 'Error','Oops, something went wrong! Please try again!');

            this.router.navigate(['/']);
        })
    }
}



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/services/search.service.ts